import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPayments = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "1em",
	viewBox: "0 -960 960 960",
	width: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M560-440q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM280-320q-33 0-56.5-23.5T200-400v-320q0-33 23.5-56.5T280-800h560q33 0 56.5 23.5T920-720v320q0 33-23.5 56.5T840-320H280Zm80-80h400q0-33 23.5-56.5T840-480v-160q-33 0-56.5-23.5T760-720H360q0 33-23.5 56.5T280-640v160q33 0 56.5 23.5T360-400Zm400 240H120q-33 0-56.5-23.5T40-240v-400q0-17 11.5-28.5T80-680q17 0 28.5 11.5T120-640v400h640q17 0 28.5 11.5T800-200q0 17-11.5 28.5T760-160ZM280-400v-320 320Z" })
});
export default SvgPayments;
